import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './App.css';
import { consumeAdminSso, isAdminSsoLanding } from './adminSsoBootstrap';

const root = createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

const renderMessage = (message) => {
  root.render(
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, sans-serif',
        color: '#111827',
        background: '#f5f7fb',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      {message}
    </div>
  );
};

if (isAdminSsoLanding()) {
  renderMessage('Entrando no painel administrativo...');
  consumeAdminSso()
    .then((redirectTo) => {
      window.location.replace(redirectTo);
    })
    .catch((error) => {
      renderMessage(
        <div>
          <p>{error?.message || 'Nao foi possivel entrar via SSO administrativo.'}</p>
          <a href="/" style={{ color: '#2563eb' }}>
            Ir para o login do painel
          </a>
        </div>
      );
    });
} else {
  renderApp();
}
